// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"embed-video-module--player-wrapper--2IJSa","reactPlayer":"embed-video-module--react-player--qSdaB"};